import React, { FunctionComponent } from 'react';

import Flex from '@gojob/ui-bits/Flex';
import Highlight from '@gojob/ui-bits/Highlight';
import PaletteProvider from '@gojob/ui-bits/styles/PaletteProvider';
import theme from '@gojob/ui-bits/styles/themes/front';

export type ArticleHighlightProps = {
  node?: {
    text?: string;
  };
};

const highlighClass = {
  '& em': {
    color: theme.colors.textDefault,
  },
};

const ArticleHighlight: FunctionComponent<ArticleHighlightProps> = (props) => {
  const { text } = props.node || {};

  if (!text) {
    return null;
  }
  return (
    <PaletteProvider variant="primary">
      <Flex justifyContent="center" margin={[4, 2]}>
        <Highlight css={highlighClass}>{text}</Highlight>
      </Flex>
    </PaletteProvider>
  );
};

const articleHighlightRenderer = (props: ArticleHighlightProps) => {
  return <ArticleHighlight {...props} />;
};

export default articleHighlightRenderer;
